"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7995],{

/***/ 37995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionSocialMediaEmbed": function() { return /* binding */ SectionSocialMediaEmbed; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75762);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55022);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30299);





const Masonry = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 5641).then(__webpack_require__.bind(__webpack_require__, 75641)).then((mod)=>mod.default), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(75641)
            ]
    },
    ssr: false
});
const ResponsiveMasonry = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 5641).then(__webpack_require__.bind(__webpack_require__, 75641)).then((mod)=>mod.ResponsiveMasonry), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(75641)
            ]
    },
    ssr: false
});
const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .SectionWrapper */ .Uq, {
    maxWidth: "$richTextWidth",
    containerSpace: "medium"
});
const Headline = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("h3", {
    marginBottom: ".75em",
    marginTop: "1.5em",
    projectFont: "heading07"
});
const EmbedWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", {
    display: "flex",
    justifyContent: "center",
    gap: "$8",
    width: "100%",
    variants: {
        width: {
            full: {
                width: "100%"
            },
            medium: {
                width: "100%",
                "@md": {
                    width: "75%"
                }
            },
            small: {
                width: "100%",
                "@md": {
                    width: "50%"
                }
            }
        },
        centered: {
            true: {
                margin: "0 auto"
            }
        }
    }
});
const SectionSocialMediaEmbed = (param)=>{
    let { headline , embeds  } = param;
    const { ref , inView  } = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_4__/* .useInView */ .YD)({
        triggerOnce: true,
        rootMargin: "500px 0px"
    });
    if (!embeds || embeds.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledSectionWrapper, {
        ref: ref,
        type: "RICH_TEXT_MD",
        children: [
            headline && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Headline, {
                children: headline
            }),
            inView && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: embeds && embeds.length === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EmbedWrapper, {
                    width: embeds[0].width,
                    centered: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Embed */ .cx, {
                        ...embeds[0]
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ResponsiveMasonry, {
                    columnsCountBreakPoints: {
                        [_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .screenSizes.sm */ .fl.sm]: 1,
                        [_portfolio_styles__WEBPACK_IMPORTED_MODULE_3__/* .screenSizes.md */ .fl.md]: 2
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Masonry, {
                        gutter: "12px",
                        children: embeds === null || embeds === void 0 ? void 0 : embeds.map((embed, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EmbedWrapper, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Embed */ .cx, {
                                    ...embed
                                })
                            }, index))
                    })
                })
            })
        ]
    });
};


/***/ })

}]);